import { render, staticRenderFns } from "./SummaryTable.vue?vue&type=template&id=517a3fbc&scoped=true&"
import script from "./SummaryTable.vue?vue&type=script&lang=ts&"
export * from "./SummaryTable.vue?vue&type=script&lang=ts&"
import style0 from "./SummaryTable.vue?vue&type=style&index=0&id=517a3fbc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517a3fbc",
  null
  
)

export default component.exports